import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Home from './pages/Home';
import './i18n'
import "antd/dist/antd.css";
import { Layout } from 'antd';
import HeaderNav from './Component/Header'
import Techs from './pages/Techs';
import Certificates from './pages/Certificates';
import Projetos from './pages/Projetos';
import AllWorks from './pages/AllWorks';
import { useTranslation } from 'react-i18next';

const { Header, Footer, Content } = Layout;

function App() {
  const {t} = useTranslation()
  return (
    <>
      <Layout style={{position: 'relative'}}>
        <Content>
          <React.StrictMode>
            <BrowserRouter>
              <Header style={{ position: 'fixed', zIndex: 999, width: '100%', padding: '0'}}>
                <HeaderNav />
              </Header>
              <Switch>
                <Route path="/" exact component={Home} />
                <Route path="/techs" component={Techs} />
                <Route path="/certificados" component={Certificates} />
                <Route path="/projetos" component={Projetos} />
                <Route path="/trabalhos" component={AllWorks} />
              </Switch>
            </BrowserRouter>
          </React.StrictMode>
        </Content>
        <Footer style={{textAlign: 'center'}}>
          {t('copy')}
        </Footer>
      </Layout>
    </>
  );
}

export default App;
